import { useEffect, useState } from "react";
import { useGetSignalUserTeams } from "applications/signal/hooks/gqlHooks";
import FullScreenLoadCircle from "applications/signal/components/FullScreenLoadCircle";
import UserTeamList from "applications/signal/components/UserTeamList";
import { AlertSnackbarProps } from "features/components/alertSnackbar";
import { setGlobalMessage } from "hooks/useGlobalMessage";

export default function UserTeamIndex() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackBarMessage, setSnackBarMessage] = useState<AlertSnackbarProps | null>(null);

  const { data, fetching, error, fetchSignalUserTeams } = useGetSignalUserTeams();
  useEffect(() => {
    // snackbarMessageを依存配列に入れることで、保存後に再取得を行う
    fetchSignalUserTeams({
      item_offset: page * rowsPerPage,
      per_page: rowsPerPage,
    });
  }, [page, rowsPerPage, snackBarMessage]);

  useEffect(() => {
    if (error) {
      setGlobalMessage({
        message: "Signalユーザーチームの取得に失敗しました。",
        severity: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    if (snackBarMessage) {
      setGlobalMessage(snackBarMessage);
    }
  }, [snackBarMessage]);

  return (
    <>
      {fetching ? <FullScreenLoadCircle /> : null}
      <UserTeamList
        rows={data?.getSignalUserTeams.teams || []}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={data?.getSignalUserTeams.totalCount || 0}
        setSnackBarMessage={setSnackBarMessage}
      />
    </>
  )
}
